module.exports = __webpack_public_path__ + "static/img/12.472185d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/12.png
// module id = YSwa
// module chunks = 0